import { useEffect, useState } from 'react';
import type { RefObject } from 'react';

/**
 * 获取元素填满剩余高度时的高度
 * @param target 选择器或元素 ref;选择器只命中页面上第一个,同页多个实例时传 ref
 */
export function useFillHeight(target: string | RefObject<HTMLElement>): [number, () => void] {
  const [height, setHeight] = useState<number>(0);

  function getHeight(): void {
    const element = typeof target === 'string' ? document.querySelector(target) : target.current;
    const { top = 0 } = element?.getBoundingClientRect() ?? {};
    setHeight(window.innerHeight - top);
  }

  useEffect(() => {
    getHeight();
    window.addEventListener('resize', getHeight);

    return (): void => {
      window.removeEventListener('resize', getHeight);
    };
  }, [target]);

  return [height, getHeight];
}
